import {inject, Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ShareChatModalComponent} from './share-chat-modal.component';
import {PolarisRuntimeFacadeService} from '../../../../services/polaris/polaris-runtime-facade.service';

@Injectable({providedIn: 'root'})
export class ShareChatService {
  private dialog = inject(MatDialog);
  private runtimeFacade = inject(PolarisRuntimeFacadeService);

  public open(chatId: string): void {
    void this.runtimeFacade.shareChat(chatId).catch(() => {
    });
    this.dialog.open(ShareChatModalComponent, {
      panelClass: 'share-chat-modal',
      autoFocus: false,
      data: {chatId}
    });
  }
}
